module.exports = __webpack_public_path__ + "static/media/aboutus-men.d0ab914c.png";